import { ChevronDown, ChevronUp } from 'lucide-react';

import { useTemplateListContext } from '@/contexts/TemplatesContext';

import { Button } from '../ui/button';
import { TableHead, TableHeader, TableRow } from '../ui/table';

const TemplateListTableHead = () => {
  const { setSortBy, setSortDirection, sortBy, sortDirection } =
    useTemplateListContext();

  const handleSort = (column) => {
    if (sortBy === column)
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    else {
      setSortBy(column);
      setSortDirection('asc');
    }
  };

  const getSortIcon = (column) => {
    if (sortBy !== column)
      return <ChevronDown className="h-4 w-4 opacity-50" />;

    return sortDirection === 'asc' ? (
      <ChevronUp className="h-4 w-4" />
    ) : (
      <ChevronDown className="h-4 w-4" />
    );
  };

  return (
    <TableHeader>
      <TableRow>
        <TableHead className="w-[120px]">
          <Button
            variant="ghost"
            className="h-auto p-0 font-semibold hover:bg-transparent"
            onClick={() => handleSort('type')}
          >
            Document Type
            {getSortIcon('type')}
          </Button>
        </TableHead>
        <TableHead>
          <Button
            variant="ghost"
            className="h-auto p-0 font-semibold hover:bg-transparent"
            onClick={() => handleSort('name')}
          >
            Template Name
            {getSortIcon('name')}
          </Button>
        </TableHead>
        <TableHead>
          <Button
            variant="ghost"
            className="h-auto p-0 font-semibold hover:bg-transparent"
            onClick={() => handleSort('creator')}
          >
            Creator
            {getSortIcon('creator')}
          </Button>
        </TableHead>
        <TableHead className="w-[100px]">
          <Button
            variant="ghost"
            className="h-auto p-0 font-semibold hover:bg-transparent"
            onClick={() => handleSort('default')}
          >
            Default
            {getSortIcon('default')}
          </Button>
        </TableHead>
        <TableHead className="w-[120px]">
          <Button
            variant="ghost"
            className="h-auto p-0 font-semibold hover:bg-transparent"
            onClick={() => handleSort('actions')}
          >
            Actions
            {getSortIcon('actions')}
          </Button>
        </TableHead>
      </TableRow>
    </TableHeader>
  );
};

export default TemplateListTableHead;
